// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13NuT","top":"styles_top__14MEQ","left":"styles_left__1dZMi","description":"styles_description__22RZ7"};